import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'src/helper/message.service';
import { AdminService } from '../admin.service';
import { emailValidationRegx } from '../shared/static-lookups/lookup';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  ConfirmCodeForm: FormGroup;
  SetPasswordForm: FormGroup;
  is_form: boolean = true;
  is_confrim_code: boolean = false;
  is_set_password: boolean = false;
  email_address: any;
  isMatch: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private apiService: AdminService,
    private messageService: MessageService,
    private _ref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadForm();
  }

  loadForm() {
    this.forgotPasswordForm = this.fb.group({
      email: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(emailValidationRegx),
          Validators.maxLength(50),
          Validators.required,
        ]),
      ],
    });
  }

  ConfirmCodeForms() {
    this.ConfirmCodeForm = this.fb.group({
      email: [
        this.email_address,
        { disabled: true },
        Validators.compose([
          Validators.required,
          Validators.pattern(emailValidationRegx),
          Validators.maxLength(50),
          Validators.required,
        ]),
      ],
      otp: ['', Validators.compose([Validators.required])],
    });
    this.ConfirmCodeForm.controls['email'].disable();
  }

  SetPasswordForms() {
    this.SetPasswordForm = this.fb.group({
      email: [
        this.email_address,
        { disabled: true },
        Validators.compose([
          Validators.required,
          Validators.pattern(emailValidationRegx),
          Validators.maxLength(50),
          Validators.required,
        ]),
      ],
      NewPassword: [
        '',
        Validators.compose([Validators.required, Validators.maxLength(50)]),
      ],
      confirm_password: [
        '',
        Validators.compose([Validators.required, Validators.maxLength(50)]),
      ],
    });
    this.SetPasswordForm.controls['email'].disable();
    this.matchpassword();
  }

  matchpassword() {
    this.SetPasswordForm.controls.confirm_password.valueChanges.subscribe(
      (t) => {
        if (
          this.SetPasswordForm.controls.NewPassword.value !=
          this.SetPasswordForm.controls.confirm_password.value
        ) {
          this.isMatch = true;
        } else {
          this.isMatch = false;
        }
      }
    );
    this.SetPasswordForm.controls.NewPassword.valueChanges.subscribe((t) => {
      if (
        this.SetPasswordForm.controls.NewPassword.value !=
          this.SetPasswordForm.controls.confirm_password.value &&
        this.SetPasswordForm.controls.confirm_password.value != null
      ) {
        this.isMatch = true;
      } else {
        this.isMatch = false;
      }
    });
  }

  async save() {
    if (this.forgotPasswordForm.valid) {
      await this.apiService
        .ForgotPassword(this.forgotPasswordForm.value)
        .then((t: any) => {
          this.messageService.successMessage('Mail Send Successfully');
          this.email_address = t.Email;
          this.is_confrim_code = true;
          this.is_form = false;
          this.ConfirmCodeForms();
          this._ref.detectChanges();
        });
    }
    this.forgotPasswordForm.markAllAsTouched();
  }

  async save2() {
    if (this.ConfirmCodeForm.valid) {
      var json = {
        email: this.forgotPasswordForm.controls.email.value,
        otp: this.ConfirmCodeForm.controls.otp.value,
      };
      await this.apiService.ConfirmCode(json).then((t) => {
        this.messageService.successMessage('OTP Verify successfully');
        this.is_set_password = true;
        this.is_confrim_code = false;
        this.SetPasswordForms();
      });
    }
    this._ref.detectChanges();
    this.ConfirmCodeForm.markAllAsTouched();
  }

  save3() {
    if (this.SetPasswordForm.valid) {
      var json1 = {
        email: this.forgotPasswordForm.controls.email.value,
        NewPassword: this.SetPasswordForm.controls.NewPassword.value,
      };
      this.apiService.SetPassword(json1).then((t) => {
        this.messageService.successMessage('New Password Set Successfully');
        this.router.navigate(['/session']);
      });
    }
    this._ref.detectChanges();
    this.SetPasswordForm.markAllAsTouched();
  }

  // helpers for View
  isControlValid(controlName: string): boolean {
    const control = this.forgotPasswordForm.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.forgotPasswordForm.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  controlHasError(validation: any, controlName: string | number): boolean {
    const control = this.forgotPasswordForm.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched(controlName: string | number): boolean {
    const control = this.forgotPasswordForm.controls[controlName];
    return control.dirty || control.touched;
  }

  // helpers for View
  isControlValid1(controlName: string): boolean {
    const control = this.SetPasswordForm.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid1(controlName: string): boolean {
    const control = this.SetPasswordForm.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  controlHasError1(validation: any, controlName: string | number): boolean {
    const control = this.SetPasswordForm.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched1(controlName: string | number): boolean {
    const control = this.SetPasswordForm.controls[controlName];
    return control.dirty || control.touched;
  }
}
